<template>
    <v-layout>
        <v-flex>
            <v-carousel v-if="featureItem.canView"
                        :prev-icon="featureItem.eventList.length === 1 ? false : undefined"
                        :next-icon="featureItem.eventList.length === 1 ? false: undefined"
                        :hide-delimiters="featureItem.eventList.length === 1"
                        class="feature-event-carousel" height="350">
                <v-carousel-item
                        v-for="(item, i) in featuredItemsToShow"
                        :key="`${i}_${item.id}`"
                        :id="`${i}_${item.id}`"
                        :interval="communityCommonConstant.featureEvent.CAROUSEL_IMAGE_TOGGLE_RATE"
                        :src="item.featuredPostImage && item.featuredPostImage.url ? item.featuredPostImage.url : ''"
                        light
                >
                    <v-layout column :class="item.isImageOverLay ? 'feature-event-carousel__overlay' : 'feature-event-carousel__details'"
                              data-qe-id="feature-event_forward-to-event_link"
                              @click="forwardToEvent(item)">
                        <div class="feature-event-carousel__details-title"
                             :data-qe-id="`feature-event_${i}_title`">
                            {{item.title}}
                        </div>
                        <div class="feature-event-carousel__details-subtitle"
                             :data-qe-id="`feature-event_${i}_sub-title`"
                             v-if="!!item.subtitle">
                            {{item.subtitle}}
                        </div>
                        <div class="feature-event-carousel__details-description"
                             :data-qe-id="`feature-event_${i}_body`">
                            {{item.body}}
                        </div>
                    </v-layout>
                    <v-btn  flat
                            fab
                            small @click="activateEdit(item.id)"
                            :data-qe-id="`feature-event_${i}_edit_link`"
                            color="white"
                            class="feature-event-carousel__edit"
                            v-if="featureItem.canEdit">
                        <v-icon>edit</v-icon>
                    </v-btn>
                </v-carousel-item>
            </v-carousel>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex';
    import { communityCommonConstant } from "../communityCommon.constant";
    import { storeMutation } from "../../../store/storeMutations.constant";
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { gaDataLayerEvent } from "../../../plugins/analytics";
    import { routerNames } from "@/components/appCommon.constants";
    import { gtmEventName } from "@/plugins/gtmAnalytics";
    import { sizeFormattedImageUrl } from "@/common/utils/cloudinaryUtils";

    export default {
        name: 'FeatureEventCarousel',
        components: {},
        data() {
            return {
                communityCommonConstant,
                sizeFormattedImageUrl,
            };
        },
        created() {
            this.$watch(
                () => `chapter/${storeGetters.featureEvents}`,
                () => this.featuredItemsToShow(),
                );
        },
        props: {
            featureItem: {
                type: Object,
                required: true,
            },
            changeCarouselComponent: {
                type: Function,
            },
        },
        methods: {
            forwardToEvent(item) {
                if (item.url) {
                    let target = '_blank';
                    if ((window && window.location && window.location.host && item.url.includes(window.location.host))
                        || this.isMobileAppBrowser) {
                        target = '_self';
                    }
                    window.open(item.url, target);
                    const isBusinessPage = this.$route && this.$route.name === routerNames.BUSINESSES;
                    if (isBusinessPage) gaDataLayerEvent(gtmEventName.C_Around_Me_Feature_Event, item.url);
                }
            },
            ...mapMutations({
                addFeatureItemToEdit: `chapter/${storeMutation.updateFeatureEventInEdit}`,
            }),
            activateEdit(eventId) {
                this.addFeatureItemToEdit(eventId);
                this.changeCarouselComponent(communityCommonConstant.featureEvent.componentNames.createFeatureEvent);
            },
        },
        computed: {
            featuredItemsToShow() {
                const featureItems = (this.featureItem && this.featureItem.eventList
                && this.featureItem.eventList.length > communityCommonConstant.featureEvent.MAX_ITEMS_FOR_CAROUSEL)
                    ? this.featureItem.eventList.slice(0, communityCommonConstant.featureEvent.MAX_ITEMS_FOR_CAROUSEL)
                    : this.featureItem.eventList;
                featureItems.forEach((fItem) => {
                  if (fItem.featuredPostImage && fItem.featuredPostImage.url) {
                    fItem.featuredPostImage = {
                      ...fItem.featuredPostImage,
                      url: sizeFormattedImageUrl(fItem.featuredPostImage.url, 500, 1250),
                    };
                  }
                });
                return featureItems;
            },
            ...mapGetters({
                isMobileAppBrowser: storeGetters.isMobileAppBrowser,
                communityInfo: `chapter/${[storeGetters.communityInfo]}`,
            }),
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .feature-event-carousel {

        &__details {
            position: absolute;
            padding: 30px 50px 70px 60px;
            font-family: Raleway, serif;
            z-index: 1;
            color: $white;
            height: 100%;
            cursor: pointer;
            width: 100%;
            &-title {
                color: $white;
                z-index: 4;
                font-size: 28px;
                font-weight: 600;
                letter-spacing: 1.66px;
                padding: 10px 0 5px;

            }

            &-subtitle {
                color: $white;
                z-index: 4;
                font-size: 22px;
                letter-spacing: 1.66px;
            }

            &-description {
                color: $white;
                z-index: 4;
                font-size: 16px;
                letter-spacing: 1.25px;
                padding: 25px 0 10px;
            }
        }
        &__overlay {
            padding: 30px 50px 70px 60px;
            word-break: break-word;
            &:after {
                content: "";
                position: absolute;
                background: $black;
                opacity: .5;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                z-index: 2;
            }
        }

        &__edit {
            z-index: 10;
            position: absolute;
            right: 10px;
            top: 0;
        }
        @include breakpoint(xs) {
            &__details {
                padding: 20px 50px 70px 60px;
                &-title {
                    font-size: 16px;
                    line-height: normal;
                    letter-spacing: 0px;
                }
                &-subtitle {
                    font-size: 14px;
                    line-height: normal;
                    letter-spacing: 0px;
                }
            }
        }
    }
</style>

<style lang="scss">
    @import '../../../common/styles/_responsive.scss';

    .feature-event-carousel {
        @include breakpoint(xs) {
            height: 200px !important;
            .v-window__container {
                height: 200px !important;
            }
            .v-carousel__item {
                height: 200px !important;
            }
        }
    }
</style>

